// Fetch memberships (public)
export const FETCH_STORE_REQUEST = 'FETCH_STORE_REQUEST';
export const FETCH_STORE_SUCCESS = 'FETCH_STORE_SUCCESS';
export const FETCH_STORE_FAILURE = 'FETCH_STORE_FAILURE';

export const fetchStoreRequest = () => ({ type: FETCH_STORE_REQUEST });
export const fetchStoreSuccess = (memberships) => ({ type: FETCH_STORE_SUCCESS, payload: memberships });
export const fetchStoreFailure = (error) => ({ type: FETCH_STORE_FAILURE, payload: error });

// One-time checkout (no login required)
export const CHECKOUT_ONETIME_REQUEST = 'CHECKOUT_ONETIME_REQUEST';
export const CHECKOUT_ONETIME_SUCCESS = 'CHECKOUT_ONETIME_SUCCESS';
export const CHECKOUT_ONETIME_FAILURE = 'CHECKOUT_ONETIME_FAILURE';

export const checkoutOnetimeRequest = (payload) => ({ type: CHECKOUT_ONETIME_REQUEST, payload });
export const checkoutOnetimeSuccess = (url) => ({ type: CHECKOUT_ONETIME_SUCCESS, payload: url });
export const checkoutOnetimeFailure = (error) => ({ type: CHECKOUT_ONETIME_FAILURE, payload: error });
